/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */
export const isSmartFolder = (content: {
	type?: string | null;
	subType?: string | null;
}): boolean => {
	return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
